import { MerchantRewardHistoryFilter } from './MerchantRewardHistory.data';

// Helper function to check if any filter is active
export const hasAnyActiveFilter = (filter: MerchantRewardHistoryFilter): boolean => {
    return Object.values(filter).some(value => {
        if (typeof value === 'string') {
            return value && value.trim() !== '';
        }
        if (typeof value === 'object' && value !== null) {
            return Object.keys(value).length > 0;
        }
        return false;
    });
};

// Helper function to clear all filters
export const getEmptyFilter = (): MerchantRewardHistoryFilter => {
    return {
        user_name: null,
        user_email: null,
        reward_name: null,
        redemption_status: null,
    };
};

